export const HUBSPOT_WRAPPER_COMPONENTS = {
  onboardingBooking: 'idopont_foglalas',
  onboardingCompanyData: 'vallalkozas_adat',
  onboardingTaxData: 'adozas_adat',
} as const

export const HUBSPOT_ACTION_IDS = {
  onboardingCompanyDataSave: 1056,
  onboardingCompanyDataSaveDraft: 1068,
  onboardingTaxDataSave: 1074,
  onboardingTaxDataSaveDraft: 1075,
  onboardingTaxDataUploadDocuments: 1073,
  onboardingJoinVideoCall: 1076,
} as const

export const HUBSPOT_DROPDOWN_EVENTS = {
  costRatio: { actionId: 1060, label: 'Költséghányad' },
  employmentType: { actionId: 1061, label: 'Jelenlegi munkavégzés jellege' },
  qualificationRequired: { actionId: 1062, label: 'Főtevékenységed szakképzettséget igényel-e' },
  mainActivity: { actionId: 1063, label: 'Főtevékenység' },
  pause: { actionId: 1069, label: 'Volt-e szüneteltetésed?' },
  inactivity: { actionId: 1070, label: 'Volt -e inaktív időszakod?' },
  szjaDiscount: { actionId: 1071, label: 'Van-e egyéb kedvezményed?' },
  otherBenefit: { actionId: 1072, label: 'Van-e egyéb ellátásod?' },
} as const

export const HUBSPOT_BLUR_EVENTS = {
  foundedAt: { actionId: 1057, label: 'Alapítás dátuma' },
  taxForm: { actionId: 1058, label: 'Adózási forma' },
  taxFormStartDate: { actionId: 1059, label: 'Adózási forma kezdete' },
  postalCode: { actionId: 1064, label: 'Irányítószám' },
  city: { actionId: 1065, label: 'Város' },
  street: { actionId: 1066, label: 'Cím' },
  adoazonosito: { actionId: 1067, label: 'Adóazonosító jel' },
} as const

export const HUBSPOT_ACTION_TYPES = {
  click: 'click',
  rollout: 'rollout',
} as const

export const HUBSPOT_COMPONENT_TYPES = {
  box: 'box',
  button: 'button',
  dropdown: 'dropdown',
} as const

export const HUBSPOT_WRAPPER_ATTRIBUTE = 'data-hubspot-wrapper'
